import { render, staticRenderFns } from "./InvoiceRevenueDetailDialog.vue?vue&type=template&id=6133231c&scoped=true"
import script from "./InvoiceRevenueDetailDialog.vue?vue&type=script&lang=js"
export * from "./InvoiceRevenueDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./InvoiceRevenueDetailDialog.vue?vue&type=style&index=0&id=6133231c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6133231c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6133231c')) {
      api.createRecord('6133231c', component.options)
    } else {
      api.reload('6133231c', component.options)
    }
    module.hot.accept("./InvoiceRevenueDetailDialog.vue?vue&type=template&id=6133231c&scoped=true", function () {
      api.rerender('6133231c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/dialog/InvoiceRevenueDetailDialog.vue"
export default component.exports